<!-- @format -->

<template>
	<iframe v-if="src" :id="pcProps.code" frameborder="0" :src="src" :style="{ width: '100%', height: pcProps.height }" />
	<el-empty v-else class="iframe-not-content" :image-size="50" description="请配置url" />
</template>

<script setup lang="ts">
	import { type WidgetConfigType } from '../../types';

	interface Props {
		modelValue: string;
		pcProps: WidgetConfigType;
	}

	const formDatas = inject('formDatas', ref({}));

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
	});

	const formDatasRef = computed(() => formDatas.value);

	const src = computed(() => {
		const url = props.modelValue || props.pcProps.linkUrl || '';
		const transUrl = url.replace(/\$\{([a-zA_Z1-9_]+)\}/g, (text) => {
			return formDatasRef.value[text.slice(2, -1)] || '';
		});

		return transUrl;
	});
</script>

<style scoped>
	.iframe-not-content {
		height: 100%;
		width: 100%;
	}
</style>
